import './VideoBlock.css';
import ScrollableBlock from "../ScrollableBlock/ScrollableBlock";
import video from '../../../assets/video/11.mp4';
import video2 from '../../../assets/video/20.1.mp4';
import video3 from '../../../assets/video/23.1.mp4';
import poster1 from '../../../assets/images/poster1.png'
import poster2 from '../../../assets/images/poster2.png'
import poster3 from '../../../assets/images/poster3.png'
function VideoBlock() {

    return (
        <ScrollableBlock>
            <p className='about-page__title about-page__video-block__title'>Video by Sany</p>
            <div className='about-page__video-block'>
                <video
                    key={`demo__video`}
                    className="about-page__video-block__video"
                    src={video}
                    // autoPlay
                    muted
                    poster={poster1}
                    playsInline
                    preload="metadata"
                    controls
                    onError={(e) => console.error("Video error:", e)}
                >
                    opss!
                </video>
                <video
                    key={`demo__video2`}
                    className="about-page__video-block__video"
                    src={video2}
                    // autoPlay
                    muted
                    playsInline
                    poster={poster2}
                    preload="metadata"
                    controls
                    onError={(e) => console.error("Video error:", e)}
                >
                    opss!
                </video>
                <video
                    key={`demo__video3`}
                    className="about-page__video-block__video"
                    src={video3}
                    // autoPlay
                    muted
                    playsInline
                    poster={poster3}
                    preload="metadata"
                    controls
                    onError={(e) => console.error("Video error:", e)}
                >
                    opss!
                </video>
            </div>
        </ScrollableBlock>
    );
}

export default VideoBlock